import { useState } from "react";
import { ViewerApi } from "@bronte/viewer-api/src/main";
import { initialSentenceOffsetData, initialWordOffsetData } from "../../shared/constants";
import { SpotlightOffsetData } from "../../shared/types";
import "./styles.scss";

interface IAudioBookDrawer {
  viewerApi: ViewerApi;
  onClose: () => void;
}

export const AudioBookDrawer = ({ viewerApi, onClose }: IAudioBookDrawer) => {
  const [dataId, setDataId] = useState("");
  const [sentenceHighlightColor, setSentenceHighlightColor] = useState("beige");
  const [sentenceOffset, setSentenceOffset] = useState(JSON.stringify(initialSentenceOffsetData));
  const [wordHighlightColor, setWordHighlightColor] = useState("lightblue");
  const [wordOffset, setWordOffset] = useState(JSON.stringify(initialWordOffsetData));

  const sendSpotlight = (): void => {
    let spotlightDataIdx = 0;
    let sentenceOffsetData: SpotlightOffsetData;
    let wordOffsetData: Array<SpotlightOffsetData>;

    if (!dataId) {
      return;
    }

    try {
      sentenceOffsetData = JSON.parse(sentenceOffset);
      wordOffsetData = JSON.parse(wordOffset);
    } catch (e) {
      console.error("JSON parsing error", e);
      return;
    }

    const intervalId = setInterval(() => {
      const currentWord = wordOffsetData[spotlightDataIdx];

      if (spotlightDataIdx === wordOffsetData.length) {
        clearInterval(intervalId);
        viewerApi.spotlight().clear();
        return;
      }

      viewerApi.spotlight().apply({
        selector: dataId,
        mark: [
          {
            ...sentenceOffsetData,
            backgroundColor: sentenceHighlightColor,
          },
          {
            ...currentWord,
            backgroundColor: wordHighlightColor,
          },
        ],
      });

      spotlightDataIdx++;
    }, 300);
  };

  return (
    <div className="drawer spotlight-drawer">
      <div className="header">
        <h3 className="title">Spotlight</h3>
        <button className="close-button" aria-label="Close button" onClick={onClose}>
          <div className="close-icon" />
        </button>
      </div>

      <div className="drawer-body">
        <div className="label">Data ID</div>
        <input
          type="text"
          name="dataId"
          aria-label="Data ID"
          value={dataId}
          onChange={(e) => setDataId(e.target.value)}
        />

        <div className="label">Sentence Highlight Color</div>
        <input
          type="text"
          name="sentenceHighlightColor"
          aria-label="Sentence Highlight Color"
          value={sentenceHighlightColor}
          onChange={(e) => setSentenceHighlightColor(e.target.value)}
        />

        <div className="label">Sentence Offset</div>
        <textarea
          rows={5}
          name="sentenceOffset"
          placeholder={`Sentence offset data in JSON format. \ne.g. {"startOffset":0,"length":40}`}
          value={sentenceOffset}
          onChange={(e) => setSentenceOffset(e.target.value)}
        />

        <div className="label">Word Highlight Color</div>
        <input
          type="text"
          name="wordHighlightColor"
          value={wordHighlightColor}
          onChange={(e) => setWordHighlightColor(e.target.value)}
        />

        <div className="label">Word Offset</div>
        <textarea
          rows={8}
          name="wordOffset"
          placeholder={`Offset data of words as Array of JSON objects. \ne.g. [\n{"startOffset":0,"length":9},\n{"startOffset":10,"length":7}\n]`}
          value={wordOffset}
          onChange={(e) => setWordOffset(e.target.value)}
        />

        <button onClick={sendSpotlight} aria-label="Spotlight">
          Spotlight
        </button>
      </div>
    </div>
  );
};
